var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3H3v6h6V3zM2 2v8h8V2H2zM9 13H3v6h6v-6zm-7-1v8h8v-8H2zM19 3h-6v6h6V3zm-7-1v8h8V2h-8zM19 13h-6v6h6v-6zm-7-1v8h8v-8h-8z",
    fill: "#fff"
  })));
}
export default SvgGallery;